import { createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";
const userDetails = localStorage.getItem("userDetails");
const userRole = userDetails ? JSON.parse(userDetails) : null;
const initialState = {
  user: null,
  loading: false,
  role: userRole?.role || null,
  token: localStorage.getItem("token") || null, // Load token from storage
  // isAuthenticated: !!localStorage.getItem("token"),
  isAuthenticated: false,
  userRoleLoaded: false, // ✅ NEW

};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      console.log("login success");
      // state.user = action.payload.user;
      // state.token = action.payload.token;
      state.isAuthenticated = true;
      // localStorage.setItem("token", action.payload.token);
    },
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
      Cookies.remove("accessToken");
      Cookies.remove("refreshToken");
      localStorage.removeItem("userDetails");
      localStorage.removeItem("supplierId");
      localStorage.removeItem("supplierName");
      localStorage.removeItem("batchNum");
      localStorage.removeItem("selectedRowKey");
      window.location.href = "/login";
    },
    setUserLoading: (state, action) => {
      console.log("Loading state set to:", action.payload);
      state.loading = action.payload;
    },
    setUserRoleLoaded: (state, action) => {
      console.log("User role loaded", action.payload);
      state.userRoleLoaded = true;
      state.role = action.payload;
    },
  },
});

export const { loginSuccess, logout, setUserRoleLoaded, setUserLoading } = authSlice.actions;
export default authSlice.reducer;
